import type {
  WrapUpTimeStartedRequest,
  WrapUpTimeStartedEventPublisher,
} from '@usecases/wrap-up-time-started.usecase';
import { publishEvent } from '@salesforce/scv-connector-base';
import { Logger } from '@main/utils/logger';
import { Constants } from '@salesforce/scv-connector-base';

export class WrapUpTimeStartedPublisher
  implements WrapUpTimeStartedEventPublisher
{
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }
  async publish(call: WrapUpTimeStartedRequest): Promise<void> {
    this.logger.info('Publisher: Wrap Up Time Started', {
      action: 'WrapUpTimeStarted',
    });
    setTimeout(() => {
      publishEvent({
        eventType: Constants.VOICE_EVENT_TYPE.AFTER_CALL_WORK_STARTED,
        payload: { callId: call.Id },
        registerLog: false,
      });
    }, 0);
  }
}
